import { useInfiniteMailBoxResults } from '@ukpostbox/client-data';
import { useMailbox } from '../../Providers/NewMailboxProvider';
import { MailboxRoot } from './MailboxRoot';

function MailboxSearchList() {
	const { searchParams } = useMailbox();

	const {
		data,
		status,
		error,
		fetchStatus,
		dataUpdatedAt,
		hasNextPage,
		fetchNextPage,
		isFetchingNextPage,
		isStale,
		isRefetching,
	} = useInfiniteMailBoxResults(searchParams);

	return (
		<MailboxRoot
			status={status}
			error={error}
			isFetchingNextPage={isFetchingNextPage}
			fetchNextPage={fetchNextPage}
			dataUpdatedAt={dataUpdatedAt}
			data={data}
			hasNextPage={hasNextPage}
			isStale={isStale}
			isRefetching={isRefetching}
		/>
	);
}

export { MailboxSearchList };
